import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../shared/custom-validators';
import {LanguageService} from '../../services/language.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {

  public errorMsg: string;
  public successMsg: string;
  private token;

  public resetPasswordForm: FormGroup;
  public acceptTerms = false;

  public firstActivation = false;

  public lang = 'de';

  constructor(private route: ActivatedRoute,
              private router: Router,
              private api: ApiService,
              private translate: TranslateService,
              private languageService: LanguageService,
              public ngxSmartModalService: NgxSmartModalService,
              private fb: FormBuilder) { }

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token');
    const lang = this.route.snapshot.paramMap.get('lang');
    this.lang = (lang) ? lang : 'de';
    this.languageService.changeLanguage(lang).subscribe(res => {
    });

    this.route.url.subscribe(
      (url) => {
        if (url[0].path === 'activate-password') {
          this.firstActivation = true;
        } else {
          this.acceptTerms = true;
        }
      }

    );
    this.resetPasswordForm = this.createResetPasswordForm();
  }

  createResetPasswordForm(): FormGroup {
    return this.fb.group({
      password: [null, Validators.compose([
        Validators.required,
        CustomValidators.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        CustomValidators.patternValidator(/[\d §!@#$%^°&*()_+-=\[\]{};':"|,.<>?`´\\]/, { hasNumberOrSpecialCharacters: true }),
        Validators.minLength(6)
      ])],
      confirmPassword: [null, Validators.compose([Validators.required])]
    }, {
      validator: CustomValidators.passwordMatchValidator
    });
  }

  sendForgotPassword() {
    const errors = this.passwordsValid();
    if (errors.length === 0 && this.token && this.acceptTerms) {
      this.api.postData('public/new-password/' + this.token, this.resetPasswordForm.controls.password.value).subscribe(result => {
        this.errorMsg = null;
        this.successMsg = this.translate.instant('_RESET_PASSWORD.SUCCESS_MSG');
        this.ngxSmartModalService.getModal('successModal').open();
      }, error => {
        console.log('error', error);
        this.errorMsg = this.translate.instant('_RESET_PASSWORD.DEFAULT_ERROR_MSG');
        this.successMsg = null;
      });
    } else {
      if (!this.acceptTerms) {
        this.errorMsg = this.translate.instant('_RESET_PASSWORD.TERMS_NOT_ACCEPTED');
      } else if (errors.some(e => e === 'NoPassswordMatch')) {
        this.errorMsg = this.translate.instant('_RESET_PASSWORD.NO_PASSWORD_MATCH');
      } else {
        this.errorMsg = this.translate.instant('_RESET_PASSWORD.NOT_VALID');
      }
      this.successMsg = null;
    }
  }

  passwordsValid(): string[] {
    const errCodes = {
      password: ['required', 'hasCapitalCase', 'hasNumberOrSpecialCharacters', 'minlength'],
      confirmPassword: ['required', 'NoPassswordMatch']
    };
    const errors = [];
    Object.keys(errCodes).forEach(controlKey => {
      errCodes[controlKey].filter(validationKey => this.resetPasswordForm.controls[controlKey].hasError(validationKey)).forEach(errCode => {
        errors.push(errCode);
      });
    });
    return errors;
  }

  removeMessages() {
    this.errorMsg = null;
    this.successMsg = null;
  }

  goToLogin() {
    this.router.navigate(['login'], {}).then();
  }

}
